import {column, Schema, Table} from '@powersync/web';

const SubmissionLinks = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    childSubmissionId: column.text,
    createDateTimeStamp: column.text,
    parentSubmissionId: column.text,
    partition: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const DocumentTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const OrgStorage = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    partition: column.text,
    size: column.integer,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const EquipmentHeavyProfiles = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    description: column.text,
    hoursUsed: column.integer,
    name: column.text,
    number: column.text,
    ownershipType: column.text,
    partition: column.text,
    photo: column.text,
    photos: column.text,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    status: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const SubmissionBundles = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    attachmentsUploaded: column.integer,
    auditSubmissionId: column.text,
    bundleAttachments: column.text,
    createDateTimeStamp: column.text,
    createdBy: column.text,
    dataHubVersion: column.integer,
    externalOrgId: column.text,
    externalRecipients: column.text,
    internalRecipients: column.text,
    isAudit: column.integer,
    name: column.text,
    partition: column.text,
    SQLServerId: column.text,
    status: column.text,
    submissions: column.text,
    submitDateTimeStamp: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const BodyParts = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const LocationTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Incidents = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    description: column.text,
    hasConflict: column.integer,
    location: column.text,
    name: column.text,
    occurenceDateTime: column.text,
    organisation: column.text,
    partition: column.text,
    personInvolved: column.text,
    project: column.text,
    reportedBy: column.text,
    SQLServerId: column.text,
    status: column.text,
    submittedEmailSent: column.integer,
    type: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Tasks = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    DatahubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    taskTypeSQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const RequestLogs = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    partition: column.text,
    requestBody: column.text,
    requestDateTime: column.text,
    requestIpAddress: column.text,
    requestMachine: column.text,
    requestMethod: column.text,
    requestType: column.text,
    requestUri: column.text,
    requestUser: column.text,
    responseCode: column.integer,
    responseMessage: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const TaskTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Mechanisms = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Locations = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const AnimalTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const SQLUsers = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    ehsId: column.text,
    email: column.text,
    firstName: column.text,
    isActive: column.integer,
    isDeleted: column.integer,
    lastName: column.text,
    partition: column.text,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    SQLServerInvitedByPersonId: column.text,
    SQLServerPersonId: column.text,
    SQLServerRoleIds: column.text,
    statusObj: column.text,
    userstatusname: column.text,
    userstatusid: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Equipments = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    equipmentTypeSQLServerId: column.text,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const PeopleTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const OrgTemplateGroups = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    partition: column.text,
    templateGroupIds: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Natures = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Jobs = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Crews = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const OperatingConditions = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const EquipmentOtherProfiles = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    description: column.text,
    name: column.text,
    number: column.text,
    ownershipType: column.text,
    partition: column.text,
    photo: column.text,
    photos: column.text,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    status: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const EquipmentTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const CertificationTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const People = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    active: column.integer,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    email: column.text,
    employeeNumber: column.text,
    fax: column.text,
    firstName: column.text,
    hireDate: column.text,
    inactiveDate: column.text,
    isActive: column.integer,
    isDeleted: column.integer,
    jobId: column.text,
    jobSQLServerId: column.text,
    lastName: column.text,
    partition: column.text,
    peopleTypeId: column.text,
    peopleTypeSQLServerId: column.text,
    phone: column.text,
    phoneDirect: column.text,
    photo: column.text,
    photoThumbnail: column.text,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    supervisorId: column.text,
    supervisorSQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const IncidentTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const MeetingTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const IncidentClassifications = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    incidentTypeSQLServerId: column.text,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Documents = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    attachmentJSON: column.text,
    createDateTimeStamp: column.text,
    createdBy: column.text,
    documentTypeId: column.text,
    name: column.text,
    partition: column.text,
    showCompanyWide: column.integer,
    showOffline: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const TrainingTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const SubmissionTrainings = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    answers: column.text,
    attachmentsUploaded: column.integer,
    certificateType: column.text,
    createdBy: column.text,
    createDateTimeStamp: column.text,
    submittedBy: column.text,
    submittedDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    metadataJSON: column.text,
    partition: column.text,
    person: column.text,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    submissionStatus: column.text,
    templateType: column.text,
    templateVersion: column.text,
    trainingType: column.text,
    updateDateTimeStamp: column.text,
    updatedBy: column.text,
    submissionstatusname: column.text,
    submissionstatusid: column.text,
    templatetypename: column.text,
    templatetypeid: column.text,
    templateversionname: column.text,
    templateversionid: column.text,
    trainingtypename: column.text,
    trainingtypeid: column.text,
    personfirstname: column.text,
    personlastname: column.text,
    submissionStatusLock: column.text,
    personid: column.text,
    certificatetypename: column.text,
    certificatetypeid: column.text,
    displayId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const EquipmentVehicleProfiles = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    description: column.text,
    distance: column.integer,
    licensePlate: column.text,
    name: column.text,
    number: column.text,
    ownershipType: column.text,
    partition: column.text,
    photo: column.text,
    photos: column.text,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    status: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const SeverityLevels = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _id__baas_transaction: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    value: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const UserCustomData = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    email: column.text,
    name: column.text,
    organisation: column.text,
    partition: column.text,
    personId: column.text,
    roles: column.text,
    sub: column.text,
    userId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Projects = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    activeEndDate: column.text,
    activeStartDate: column.text,
    address: column.text,
    cityName: column.text,
    citySQLServerId: column.text,
    countrySQLServerId: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    location: column.text,
    name: column.text,
    partition: column.text,
    postalZip: column.text,
    projectManagerId: column.text,
    projectManagerSQLServerId: column.text,
    provStateSQLServerId: column.text,
    safetyResourceId: column.text,
    safetyResourceSQLServerId: column.text,
    siteSupervisorId: column.text,
    siteSupervisorSQLServerId: column.text,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    workers: column.text,
    workersJSON: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const HazardTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Shifts = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const SubmissionRelations = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    partition: column.text,
    relationId: column.text,
    relationType: column.text,
    submissionId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Departments = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const IncidentProbabilities = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    value: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Dispositions = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    _t: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const UserIncidents = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    description: column.text,
    hasConflict: column.integer,
    history: column.text,
    location: column.text,
    name: column.text,
    occurenceDateTime: column.text,
    organisation: column.text,
    partition: column.text,
    personInvolved: column.text,
    project: column.text,
    reportedBy: column.text,
    SQLServerId: column.text,
    status: column.text,
    submittedEmailSent: column.integer,
    type: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const OrgRelations = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    childName: column.text,
    childOrgId: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    isDeleted: column.integer,
    parentName: column.text,
    parentOrgId: column.text,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Organisations = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    headOfficeLocationJSON: column.text,
    isActive: column.integer,
    isDeleted: column.integer,
    name: column.text,
    CORNumber: column.text,
    SAFENumber: column.text,
    WSBCNumber: column.text,
    WSBCUnitsJSON: column.text,
    mainActivities: column.text,
    mailingLocationJSON: column.text,
    primaryContactJSON: column.text,
    auditContactJSON: column.text,
    safetyContactJSON: column.text,
    tradeName: column.text,
    ownersJSON: column.text,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    OrgTagPublic: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const OrgContractorNotificationRecipients = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    email: column.text,
    firstName: column.text,
    isDeleted: column.integer,
    lastName: column.text,
    orgId: column.text,
    SQLServerId: column.text,
    SQLServerPersonId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const ToDo = new Table(
  {
    // id column (text) is automatically included
    test_date: column.text,
    _id: column.text,
    completed: column.integer,
    name: column.text,
    partition: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Submissions = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    answers: column.text,
    attachmentsUploaded: column.integer,
    createdBy: column.text,
    createDateTimeStamp: column.text,
    submittedBy: column.text,
    submittedDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    metadataJSON: column.text,
    partition: column.text,
    SQLDataHubVersion: column.integer,
    SQLServerId: column.text,
    submissionStatus: column.text,
    submissionStatusLock: column.text,
    templateType: column.text,
    templateVersion: column.text,
    updateDateTimeStamp: column.text,
    updatedBy: column.text,
    submissionstatusname: column.text,
    submissionstatusid: column.text,
    templatetypename: column.text,
    templatetypeid: column.text,
    templateversionname: column.text,
    templateversionid: column.text,
    displayId: column.text,
    isArchived: column.integer,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Permissions = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    name: column.text,
    roles: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const TemplateVersionConversions = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    conversions: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    fromTemplateVersionId: column.text,
    partition: column.text,
    toTemplateVersionId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const EmailTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    description: column.text,
    name: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Roles = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    description: column.text,
    name: column.text,
    sortOrder: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const UserStatuses = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    name: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const UserRequestLogs = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    partition: column.text,
    requestDateTime: column.text,
    requestIpAddress: column.text,
    requestMachine: column.text,
    requestMethod: column.text,
    requestType: column.text,
    requestUri: column.text,
    requestUser: column.text,
    responseCode: column.integer,
    responseMessage: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const ClassificationUnits = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    name: column.text,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const TemplateVersions = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    conditions: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    displayName: column.text,
    name: column.text,
    pages: column.text,
    templateId: column.text,
    version: column.integer,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const OIICS_Sources = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    name: column.text,
    oiics_id: column.text,
    parentid: column.text,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const TemplateTypes = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    name: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const TemplateCategories = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    name: column.text,
    sortOrder: column.integer,
    listTemplateIds: column.text,
    actionTemplateIds: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const ControlTypes = new Table(
  {
    // id column (text) is automatically included
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const OIICS_Natures = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    name: column.text,
    oiics_id: column.text,
    parentid: column.text,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const OIICS_BodyParts = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    name: column.text,
    oiics_id: column.text,
    parentid: column.text,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const ProvStates = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    countrySQLServerId: column.text,
    createDateTimeStamp: column.text,
    provState: column.text,
    provStateCode: column.text,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const EquipmentProfileTypes = new Table(
  {
    // id column (text) is automatically included  _id: x._id!,
    _id: column.text,
    name: column.text,
    partition: column.text,
    sortOrder: column.integer,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Countries = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    countryCode: column.text,
    countryName: column.text,
    createDateTimeStamp: column.text,
    sortOrder: column.integer,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const SubmissionStatuses = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    name: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Cities = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    cityName: column.text,
    createDateTimeStamp: column.text,
    provStateSQLServerId: column.text,
    SQLServerId: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const TemplateGroups = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    conditions: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    name: column.text,
    pages: column.text,
    templateId: column.text,
    templateIds: column.text,
    version: column.integer,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const Templates = new Table(
  {
    // id column (text) is automatically included
    _id: column.text,
    createDateTimeStamp: column.text,
    dataHubVersion: column.integer,
    iconSvg: column.text,
    name: column.text,
    order: column.integer,
    row: column.integer,
    templateCategory: column.text,
    templateType: column.text,
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

const AuditRequests = new Table(
  {
    // id column (text) is automatically included
  },
  {indexes: {id : ['id'], _id : ['_id']}},
);

export const AppSchema = new Schema({
  SubmissionLinks,
  DocumentTypes,
  OrgStorage,
  EquipmentHeavyProfiles,
  SubmissionBundles,
  BodyParts,
  LocationTypes,
  Incidents,
  Tasks,
  RequestLogs,
  TaskTypes,
  Mechanisms,
  Locations,
  AnimalTypes,
  SQLUsers,
  Equipments,
  PeopleTypes,
  OrgTemplateGroups,
  Natures,
  Jobs,
  Crews,
  OperatingConditions,
  EquipmentOtherProfiles,
  EquipmentTypes,
  CertificationTypes,
  People,
  IncidentTypes,
  MeetingTypes,
  IncidentClassifications,
  Documents,
  TrainingTypes,
  SubmissionTrainings,
  EquipmentVehicleProfiles,
  SeverityLevels,
  UserCustomData,
  Projects,
  HazardTypes,
  Shifts,
  SubmissionRelations,
  Departments,
  IncidentProbabilities,
  Dispositions,
  UserIncidents,
  OrgRelations,
  Organisations,
  OrgContractorNotificationRecipients,
  ToDo,
  Submissions,
  Permissions,
  TemplateVersionConversions,
  EmailTypes,
  Roles,
  UserStatuses,
  UserRequestLogs,
  ClassificationUnits,
  TemplateVersions,
  OIICS_Sources,
  TemplateTypes,
  TemplateCategories,
  ControlTypes,
  OIICS_Natures,
  OIICS_BodyParts,
  ProvStates,
  EquipmentProfileTypes,
  Countries,
  SubmissionStatuses,
  Cities,
  TemplateGroups,
  Templates,
  AuditRequests,
});

export type Database = (typeof AppSchema)['types'];

export type AnimalTypes = Database['AnimalTypes'];
export type BodyParts = Database['BodyParts'];
export type CertificationTypes = Database['CertificationTypes'];
export type Cities = Database['Cities'];
export type ClassificationUnits = Database['ClassificationUnits'];
export type ControlTypes = Database['ControlTypes'];
export type Countries = Database['Countries'];
export type Crews = Database['Crews'];
export type Departments = Database['Departments'];
export type Dispositions = Database['Dispositions'];
export type Documents = Database['Documents'];
export type DocumentTypes = Database['DocumentTypes'];
export type EmailTypes = Database['EmailTypes'];
export type EquipmentHeavyProfiles = Database['EquipmentHeavyProfiles'];
export type EquipmentOtherProfiles = Database['EquipmentOtherProfiles'];
export type EquipmentProfileTypes = Database['EquipmentProfileTypes'];
export type Equipments = Database['Equipments'];
export type EquipmentTypes = Database['EquipmentTypes'];
export type EquipmentVehicleProfiles = Database['EquipmentVehicleProfiles'];
export type HazardTypes = Database['HazardTypes'];
export type IncidentClassifications = Database['IncidentClassifications'];
export type IncidentProbabilities = Database['IncidentProbabilities'];
export type Incidents = Database['Incidents'];
export type IncidentTypes = Database['IncidentTypes'];
export type Jobs = Database['Jobs'];
export type Locations = Database['Locations'];
export type LocationTypes = Database['LocationTypes'];
export type Mechanisms = Database['Mechanisms'];
export type MeetingTypes = Database['MeetingTypes'];
export type Natures = Database['Natures'];
export type OIICS_BodyParts = Database['OIICS_BodyParts'];
export type OIICS_Natures = Database['OIICS_Natures'];
export type OIICS_Sources = Database['OIICS_Sources'];
export type OperatingConditions = Database['OperatingConditions'];
export type Organisations = Database['Organisations'];
export type OrgContractorNotificationRecipients =
  Database['OrgContractorNotificationRecipients'];
export type OrgRelations = Database['OrgRelations'];
export type OrgStorage = Database['OrgStorage'];
export type OrgTemplateGroups = Database['OrgTemplateGroups'];
export type People = Database['People'];
export type PeopleTypes = Database['PeopleTypes'];
export type Permissions = Database['Permissions'];
export type Projects = Database['Projects'];
export type ProvStates = Database['ProvStates'];
export type RequestLogs = Database['RequestLogs'];
export type Roles = Database['Roles'];
export type SeverityLevels = Database['SeverityLevels'];
export type Shifts = Database['Shifts'];
export type SQLUsers = Database['SQLUsers'];
export type SubmissionBundles = Database['SubmissionBundles'];
export type SubmissionRelations = Database['SubmissionRelations'];
export type Submissions = Database['Submissions'];
export type SubmissionStatuses = Database['SubmissionStatuses'];
export type SubmissionTrainings = Database['SubmissionTrainings'];
export type Tasks = Database['Tasks'];
export type TaskTypes = Database['TaskTypes'];
export type TemplateCategories = Database['TemplateCategories'];
export type TemplateGroups = Database['TemplateGroups'];
export type Templates = Database['Templates'];
export type TemplateTypes = Database['TemplateTypes'];
export type TemplateVersionConversions = Database['TemplateVersionConversions'];
export type TemplateVersions = Database['TemplateVersions'];
export type TrainingTypes = Database['TrainingTypes'];
export type UserCustomData = Database['UserCustomData'];
export type UserIncidents = Database['UserIncidents'];
export type UserRequestLogs = Database['UserRequestLogs'];
export type UserStatuses = Database['UserStatuses'];
export type SubmissionLinks = Database['SubmissionLinks'];
